var utils = require('./utils');
var config = require('../config');
var isInit = true;
var $html = $('html');

function init(){
  bindEvents();
  checkScrollPosition();
}

function bindEvents(){
  var debouncedScrollHandler = utils.debounce(checkScrollPosition, 100);
  
  $(window).on('scroll', debouncedScrollHandler);
  $(document).on(utils.clickEvent, '.story-cta', scrollToggle);

  scrollToggle();
}

function scrollToggle(){
  var scrollTo = window.innerHeight;
  
  if($('html').hasClass('is-text-mode')){
    scrollTo = 0;
    utils.deactivateTextMode();
    utils.activateMapMode();
  }else{
    utils.activateTextMode();
    utils.deactivateMapMode();
  }
  
  if(!isInit){
    $('html, body').animate({ scrollTop : scrollTo }, 600);
  }else{
    isInit = false;
  }
  
}

function checkScrollPosition(){

  if(window.scrollY <= 1){
    utils.deactivateTextMode();
  }
  else if(window.scrollY > $('#map').outerHeight()){
    utils.deactivateMapMode();
  }
  else if(window.scrollY > 1){
    utils.activateTextMode();
  }
  
}

module.exports = {
  init: init
}